import React from 'react';
import { Bug } from 'lucide-react';
import type { LucideProps } from 'lucide-react';

/**
 * Debug icon component
 * Wraps the Lucide Bug icon for debug/diagnostics features
 */
export const DebugIcon: React.FC<LucideProps> = (props) => {
  return <Bug {...props} />;
};
